var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9974 11.6665C10.4576 11.6665 10.8307 11.2934 10.8307 10.8332V6.66651C10.8307 6.20627 10.4576 5.83318 9.9974 5.83318C9.53716 5.83318 9.16406 6.20627 9.16406 6.66651V10.8332C9.16406 11.2934 9.53716 11.6665 9.9974 11.6665Z",
    fill: "#6B6862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8307 13.3333C10.8307 13.7936 10.4576 14.1667 9.9974 14.1667C9.53716 14.1667 9.16406 13.7936 9.16406 13.3333C9.16406 12.8731 9.53716 12.5 9.9974 12.5C10.4576 12.5 10.8307 12.8731 10.8307 13.3333Z",
    fill: "#6B6862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9974 16.6665C13.6793 16.6665 16.6641 13.6817 16.6641 9.99984C16.6641 6.31794 13.6793 3.33317 9.9974 3.33317C6.3155 3.33317 3.33073 6.31794 3.33073 9.99984C3.33073 13.6817 6.3155 16.6665 9.9974 16.6665ZM9.9974 18.3332C14.5998 18.3332 18.3307 14.6022 18.3307 9.99984C18.3307 5.39746 14.5998 1.6665 9.9974 1.6665C5.39502 1.6665 1.66406 5.39746 1.66406 9.99984C1.66406 14.6022 5.39502 18.3332 9.9974 18.3332Z",
    fill: "#6B6862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.843723312fdda978f09325c02ab81f96.svg";
export { ForwardRef as ReactComponent };